import { UserDetails } from "@fidget/common/models/user-details";
import { WindowWithApi } from "@fidget/common/models/window-api";
import { Instance, types } from "mobx-state-tree";
import { currentUserStoreGetter, servicesGetters } from "../utils";

export const WidgetStore = types
  .model("WidgetStore")
  .views(servicesGetters)
  .views(currentUserStoreGetter)
  .volatile((self) => ({
    setup(widgetUrl: string) {
      const api = window as WindowWithApi & typeof globalThis;
      api.closer = api.closer || { q: [] };
      ["init", "identify", "openWidget"].forEach((val) => {
        const methodName = val as "init" | "identify" | "openWidget";
        api.closer[methodName] = function () {
          if (api.closer.q !== undefined) {
            api.closer.q.push({ method: methodName, args: arguments as any });
          }
          return true; // FIXME: it's a weird hack, need to investigate more how the widget initialize
        };
      });
      api.closer.scriptUrl = widgetUrl;
    },

    updateUserDetails(userDetails: UserDetails) {
      const api = (window as WindowWithApi & typeof globalThis).closer;
      if (api) {
        api.identify(userDetails);
      }
    },

    init(closerOrgId: string) {
      const api = (window as WindowWithApi & typeof globalThis).closer;
      const user = self.currentUserStore;
      api.init({
        orgId: closerOrgId,
        apiKey: user.profile!.closerCustomerApiKey
      });
      const { firstName, lastName, email, phone, role, orgId } = user.profile!;

      const { name, baseUrl } = user.orgConfig!;
      api.identify({
        firstName,
        lastName,
        email: email || "",
        phone,
        tag: "in-app",
        additionalData: {
          "Company name": name,
          "Company URL": baseUrl,
          "Company ID": orgId,
          "Role": role,
          "Plan": "Launch"
        }
      });
    },

    openWidget() {
      const api = (window as WindowWithApi & typeof globalThis).closer;
      api.openWidget();
    }
  }));

export type IWidgetStore = Instance<typeof WidgetStore>;
